import { FRONTEND_PORT, API_PORT, RSS_LINKS_PORT } from "./constants";

// DO NOT PUT SECRETS IN HERE!!!
const development = {
  flags: {
    enableEuSettingsPopup: true,
    enableHomepage: true,
    enableHomepageTabs: true,
    enableInitialReadoutExperience: true,
    enableKeywordsOnSharedTopicReport: true,
    enableSalesforceIntegration: true,
    enableSpanishLocale: true,
    enableMobileNav: true,
  },
  FRONTEND_URL:
    import.meta.env.VITE_APP_FRONTEND_URL ||
    `http://localhost:${FRONTEND_PORT}`,
  RECORDINGS_URL:
    import.meta.env.VITE_APP_RECORDINGS_URL || `http://localhost:${API_PORT}`,
  RSS_LINKS_URL:
    import.meta.env.VITE_APP_RSS_LINKS_URL ||
    `http://localhost:${RSS_LINKS_PORT}`,
  api: {
    HOST: import.meta.env.VITE_APP_API_HOST || `http://localhost:${API_PORT}`,
    // TODO: set up dummy data so metrics queries don't throw 500s when
    //  running locally
    disableMetricsQueries:
      import.meta.env.VITE_APP_DISABLE_METRICS_QUERIES === "true",
  },
  booking: {
    enableDevRoutes:
      import.meta.env.VITE_APP_ENABLE_BOOKING_DEV_ROUTES !== "false",
  },
  tracking: {
    DEBUG: true,
    ENABLED: false,
    GOOGLE_ID: "G-JQN958QXJF",
    MIXPANEL_VERBOSE_LOG: true,
    MIXPANEL_ID: "d34b18861b5c0ad5ffe89d8d307bdcdc",
    STATSIG_KEY: "client-ntzxY8eFoeabjvRLm0AvTF1uFPkb9X7Qu8w1EmeRKH1",
  },
  stripe: {
    publishableKey:
      "pk_test_51LB55RKEmPi2JwflCpilDUymp0vQWHIR7U2mMrUEZBqNlXHfdPMBec78tRyEWFlL2y8G5wFCuVF0KgNypBB5k4kK007gYtiU11",
    subscriptionCheckoutReturnUrl:
      import.meta.env.VITE_APP_STRIPE_SUBSCRIPTION_CHECKOUT_RETURN_URL ||
      `http://localhost:${API_PORT}/billing/checkout-confirm-return`,
    creditCheckoutReturnUrl:
      import.meta.env.VITE_APP_STRIPE_CREDIT_CHECKOUT_RETURN_URL ||
      `http://localhost:${API_PORT}/billing/credit-checkout-confirm-return`,
    setupReturnUrl:
      import.meta.env.VITE_APP_STRIPE_SETUP_RETURN_URL ||
      `http://localhost:${API_PORT}/billing/setup-confirm-return`,
  },
  billing: {
    zeroBalancePriceIds: [
      "price_1M5H30KEmPi2JwflDrJv1i1R", // Read Free
      "price_1MFPTMKEmPi2JwflboZ0d3Oz", // Read Zoom
    ],
    prices: {
      byPriceId: {
        // updated prices
        price_1NuLglKEmPi2JwflT8dFtG1e: 39.75, // monthly enterprise+
        price_1NwtDMKEmPi2JwflOoRsV3Xu: 29.75, // annual enterprise+
        price_1NZz6bKEmPi2JwflxbtLnakM: 29.75, // monthly enterprise
        price_1NZz5mKEmPi2JwflRJmQNiOM: 22.5, // annual enterprise
        price_1NZz85KEmPi2JwflFQyb68bJ: 19.75, // monthly pro
        price_1NZz7nKEmPi2JwflH21Vb6oL: 15, // annual pro
        // legacy prices (do not remove a price from here unless there are 0 active subscriptions with these price ids!)
        price_1M5Gy5KEmPi2Jwfl7Ko3H4im: 25, // monthly enterprise
        price_1MHDQnKEmPi2JwflO9OeJxhg: 16.5, // annual enterprise
        price_1MHDPgKEmPi2JwflclMIvltK: 10, // annual pro
        price_1M5GxKKEmPi2JwflOpKMMBhP: 15, // monthly pro
      } as Record<string, number | undefined>,
    },
    promotions: {
      trial_extension_on_purchase: "40558D39F15B8083C47214246",
    },
  },
  apps: {
    teams: {
      AAD_CLIENT_ID: "35e7f5d2-9978-464f-8710-c7a05d5b9fdf",
      APP_ID: "18eb20ae-cd59-48c6-8060-fbe171a917e5",
    },
    zoom: {
      INSTALL_URL: `${
        import.meta.env.VITE_APP_API_HOST ?? "http://localhost:8000"
      }/zoomapp/install`,
    },
    meet: {
      CLOUD_PROJECT_NUMBER: import.meta.env.VITE_APP_MEET_ADD_ON_PROJECT_NUMBER,
      CLIENT_ID:
        "307358853148-pfp68q0vqgukrgevecaa3k4e34742hoq.apps.googleusercontent.com",
    },
  },
  statusMessage: {
    enabled: [],
  },
  // Test key
  recaptchaSite: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
};

export type Config = typeof development;
export default development;
